module.exports = __webpack_public_path__ + "static/media/gold.b5be68fa.png";